<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xii"></a><a id="page_xiii"></a><strong>P<span class="small">LANNING FOR</span> U<span class="small">NCERTAINTY</span></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle2.vue?dc0f6276